module.exports = __webpack_public_path__ + "static/media/1717128338753-min.370e3997.JPG";